import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from "react-select";
import { getSelectList } from '../../config/utils';
import { useSelector, useDispatch } from 'react-redux';
import { fetchCompanyFilters, getFilterSellers } from '../../store/actions/rateCard';
import _ from 'lodash';

/* istanbul ignore next */
const RentConfigurationFilter = (props) => {
    const { showFilter, handleReset, filterData, setfilterData, handleFilter } = props;
    const [companyList, setCompanyList] = useState([]);
    const [sellerList, setSellerList] = useState([]);
    const [allSellers, setAllSellers] = useState([]);
    const dispatch = useDispatch();
    const userDetails = useSelector((state) => state.auth.user);
    const { filterCompanies, filterAllSellers } = useSelector((state) => state.RateCardReducer);

    const rentFrequencyOptions = [
        { label: 'Daily', value: 'Daily' },
        { label: 'Weekly', value: 'Weekly' },
        { label: 'Monthly', value: 'Monthly' },
        { label: 'Quarterly', value: 'Quarterly' },
        { label: 'Yearly', value: 'Yearly' }
    ];

    useEffect(() => {
        if (filterCompanies && filterCompanies.length > 0) {
            const filteredCompanies = filterCompanies.filter(item => item?.Id !== 0);
            setCompanyList(getSelectList(filteredCompanies, 'Id', 'Name'));
        }
    }, [filterCompanies]);

    useEffect(() => {
        if (userDetails?.Value?.roleName !== 'Seller') {
            dispatch(fetchCompanyFilters());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (filterAllSellers && filterAllSellers.length > 0) {
            const filteredSellers = filterAllSellers.filter(item => item?.Id !== 0);
            setAllSellers(getSelectList(filteredSellers, 'Id', 'Name'));
        }
    }, [filterAllSellers]);

    const handleCompanyChange = (e) => {
        setfilterData({
            ...filterData,
            companyIdList: e || [],
            sellerIdList: []
        });
        setSellerList([]);
        
        if (e && e.length > 0) {
            const companyIds = e.map(company => company.value);
            let sellerData = {
                "pageIndex": 1,
                "pageSize": 100,
                "sortColumn": "name",
                "sortOrder": "ASCENDING",
                "companyIdList": companyIds,
                screenType: 2,
            };
            dispatch(getFilterSellers(sellerData));
        }
    };

    const handleSellerChange = (e) => {
        setfilterData({
            ...filterData,
            sellerIdList: e || []
        });
        if (e && e.length > 0) {
            const sellerIds = e.map(item => item.value); // NOSONAR
            const sellers = filterAllSellers.filter(seller => sellerIds.includes(seller.Id));
            setSellerList(getSelectList(sellers, 'Id', 'Name'));
        } else {
            setSellerList([]);
        }
    };

    const handleRentFrequencyChange = (e) => {
        setfilterData({
            ...filterData,
            rentFrequencyList: e || []
        });
    };

    const handleResetFilter = () => {
        setSellerList([]);
        handleReset();
    };

    const handleApplyFilter = () => {
        // Close filter and trigger parent's filter handler
        handleFilter();
    };

    return (
        <div className={showFilter ? 'filterContainer filterContainerZIndex show historyFilter zIndex2' : 'filterContainer historyFilter'}
             style={{
                 background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                 border: '1px solid #dee2e6',
                 borderRadius: '8px',
                 padding: '12px',
                 marginBottom: '15px',
                 boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                 position: 'relative',
                 overflow: 'visible',
                 zIndex: 10
             }}>
            {/* Decorative element */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '3px',
                background: 'linear-gradient(90deg, #007bff 0%, #28a745 50%, #ffc107 100%)'
            }}></div>

            {/* Filter Header */}
            <div style={{
                marginBottom: '12px',
                paddingBottom: '8px',
                borderBottom: '1px solid #e9ecef',
                position: 'relative'
            }}>
                <h6 style={{
                    margin: 0,
                    color: '#495057',
                    fontSize: '13px',
                    fontWeight: '600',
                    letterSpacing: '0.3px'
                }}>
                    <i className="fa fa-filter" style={{ marginRight: '8px', color: '#007bff' }}></i>{' '}
                    Filter Options
                </h6>
            </div>

            {/* Filter Body */}
            <div className="row fontFix">
                {/* Rent Frequency Filter */}
                <div className='col-lg-2 col-md-4 col-sm-6 col-12' style={{ marginBottom: '8px', padding: '0 4px' }}>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='labelHead' style={{
                                fontWeight: '600',
                                color: '#495057',
                                marginBottom: '3px',
                                fontSize: '12px',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <i className="fa fa-clock-o" style={{
                                    marginRight: '3px',
                                    color: '#6c757d',
                                    fontSize: '10px'
                                }}></i> Rent Frequency
                            </div>
                        </div>
                        <div className='col-12 fontFix'>
                            <Select
                                isMulti
                                name="rentFrequency"
                                options={rentFrequencyOptions}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                value={filterData.rentFrequencyList || []}
                                onChange={handleRentFrequencyChange}
                                placeholder="Select Rent Frequency"
                                isClearable={true}
                            />
                        </div>
                    </div>
                </div>

                {/* Company Filter */}
                {userDetails?.Value?.roleName !== 'Seller' && (
                    <div className='col-lg-2 col-md-4 col-sm-6 col-12' style={{ marginBottom: '8px', padding: '0 4px' }}>
                        <div className='row'>
                            <div className='col-12'>
                                <div className='labelHead' style={{
                                    fontWeight: '600',
                                    color: '#495057',
                                    marginBottom: '3px',
                                    fontSize: '12px',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    <i className="fa fa-building" style={{
                                        marginRight: '3px',
                                        color: '#6c757d',
                                        fontSize: '10px'
                                    }}></i> Company
                                </div>
                            </div>
                            <div className='col-12 fontFix'>
                                <Select
                                    isMulti
                                    name="company"
                                    options={companyList}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    value={filterData.companyIdList || []}
                                    onChange={handleCompanyChange}
                                    placeholder="Select Company"
                                    isClearable={true}
                                />
                            </div>
                        </div>
                    </div>
                )}

                {/* Seller Filter */}
                {userDetails?.Value?.roleName !== 'Seller' && (
                    <div className='col-lg-2 col-md-4 col-sm-6 col-12' style={{ marginBottom: '8px', padding: '0 4px' }}>
                        <div className='row'>
                            <div className='col-12'>
                                <div className='labelHead' style={{
                                    fontWeight: '600',
                                    color: '#495057',
                                    marginBottom: '3px',
                                    fontSize: '12px',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    <i className="fa fa-user" style={{
                                        marginRight: '3px',
                                        color: '#6c757d',
                                        fontSize: '10px'
                                    }}></i> Seller
                                </div>
                            </div>
                            <div className='col-12 fontFix'>
                                <Select
                                    isMulti
                                    name="seller"
                                    options={sellerList.length > 0 ? sellerList : allSellers}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    value={filterData.sellerIdList || []}
                                    onChange={handleSellerChange}
                                    placeholder="Select Seller"
                                    isClearable={true}
                                />
                            </div>
                        </div>
                    </div>
                )}

                {/* Action Buttons - right aligned across the filter section */}
                <div className='col-12 mt-3'>
                    <div className='d-flex justify-content-end align-items-center' style={{ padding: '0 12px' }}>
                        <div className='d-flex gap-3 align-items-center'>
                            <button
                                className="btn cus-primary-transparent-btn clrBtn"
                                onClick={handleResetFilter}
                                style={{
                                    padding: '8px 16px',
                                    borderRadius: '6px',
                                    fontSize: '12px',
                                    fontWeight: '500',
                                    transition: 'all 0.3s ease',
                                    border: '1px solid #6c757d'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#f8f9fa';
                                    e.target.style.borderColor = '#dc3545';
                                    e.target.style.color = '#dc3545';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = 'transparent';
                                    e.target.style.borderColor = '#6c757d';
                                    e.target.style.color = '#6c757d';
                                }}
                            >
                                <i className="fa fa-eraser" style={{ marginRight: '6px', fontSize: '11px' }}></i> Clear Filter
                            </button>
                            <button
                                className="btn cus-seconday-bg-btn marginLeft5 searchBtn"
                                onClick={handleApplyFilter}
                                style={{
                                    padding: '8px 20px',
                                    borderRadius: '6px',
                                    fontSize: '12px',
                                    fontWeight: '500',
                                    transition: 'all 0.3s ease',
                                    boxShadow: '0 2px 4px rgba(0, 123, 255, 0.2)'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'translateY(-1px)';
                                    e.target.style.boxShadow = '0 4px 8px rgba(0, 123, 255, 0.3)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 2px 4px rgba(0, 123, 255, 0.2)';
                                }}
                            >
                                <i className="fa fa-check" style={{ marginRight: '6px', fontSize: '11px' }}></i> Apply
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

RentConfigurationFilter.propTypes = {
    showFilter: PropTypes.bool.isRequired,
    handleReset: PropTypes.func.isRequired,
    filterData: PropTypes.object.isRequired,
    setfilterData: PropTypes.func.isRequired,
    handleFilter: PropTypes.func.isRequired
};

export default RentConfigurationFilter;
